import React from "react";
import { Link } from "react-router-dom";

import infoHeading from "../../../assets/info-heading.png";
import infoBackground from "../../../assets/background-info.svg";
import arrowDownSvg from "../../../assets/arrow-down-1.svg";
import searchIcon from "../../../assets/search-icon-white.svg";
import useWindowDimensions from "../../../misc/windowDimensions";

export default function HeroInfo({ thumbnail }) {
  const { height, width } = useWindowDimensions();
  console.log('checking thumbnail ', thumbnail)
  return (
    <section style={{ padding: "0px 30px" }}>
      <div
        className="container"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div
          className="wrapper-hero row"
          style={{
            // height: 420,
            width: "100%",
            flexDirection: "row",
          }}
        >
          <div
            className="col-lg-6 col-12 order-lg-last"
            style={{
              display: "flex",
              padding: 0,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                // width: "100%",
              }}
            >
              {/* <img
                className="mb-0 d-none d-lg-block"
                src={infoBackground}
                alt="grey"
                style={{ height: "310px", objectFit: "contain" }}
              /> */}
              {thumbnail && <img
                className="mb-0"
                src={`${process.env.REACT_APP_BASE_URL}/${thumbnail}`}
                alt="slide3"
                style={{
                  // maxHeight: "350px",
                  // maxWidth: "100%",
                  height: '350px',
                  width: '625px',
                  objectFit: 'fill',
                  // objectFit: "contain",
                  borderRadius: 5,
                }}
              />}
            </div>
            {/* <div
              style={{
                width: "500px",
                height: "256px",
                position: "absolute",
                top: "50%",
                bottom: "50%",
                right: 80,
                transform: "translate(0, -50%)",
                display: "flex",
                borderRadius: "5px",
                justifyContent: "center",
              }}
            >
              <img
                className="mb-0"
                src={infoHeading}
                alt="slide3"
                style={{
                  height: "300px",
                  objectFit: "cover",
                  borderRadius: 5,
                }}
              />
            </div> */}
          </div>
          <div
            className="col-lg-6 col-12 order-lg-first"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: width < 768 ? "flex-start" : "center",
            }}
          >
            <p className="p-nunito" style={{ color: "#1672BD" }}>
              Yuk mengenal tentang layanan
            </p>
            <h1 className="h1-nunito">
              Penyelenggara Sertifikasi Elektronik (PSrE){" "}
              <span style={{ color: "#1672BD" }}>Indonesia</span>
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
}
